import { useState, useEffect } from 'react';
import { HostBackend } from '../../Routes/HostBackend.js';
import { GetHeaders } from '../../Components/Admin/Functions/FetchHeaders.js';
import { LogoImgHistory } from '../../Files/LogoImgHistory.js';
import { FilterHistoryYears } from '../../Components/Public/Filters/FilterHistoryYears.js';
import { GetYearMonthDay, GetDateShortFR, GetYear } from '../../Components/Public/Functions/GetDates.js';
import { ScrollTop } from '../../Components/Public/Functions/ScrollTop.js';
/* document */
import { Navigation } from '../../Components/Public/Document/Navigation.js';
import { Header } from '../../Components/Public/Document/Header.js';
import { Footer } from '../../Components/Public/Document/Footer.js';
import { BreadCrumb } from '../../Components/Public/Document/Breadcrumb.js';
import { BreadTagsHistory } from '../../Components/Public/Document/BreadTagsHistory.js';
import { BlockGallery } from '../../Components/Public/Blocks/BlockGallery.js';
import { BackTop } from '../../Components/Public/Document/BackTop.js';

export const History = (props) => {
    const { navParks } = props;
    const backend = HostBackend();
    const guest = sessionStorage.getItem('guest');
    const [history, setHistory] = useState([]);
    useEffect(() => {
        const fetchtheData = async () => {
            const dataHistory = await fetch(`${backend}/history`, GetHeaders(guest));
            const history = await dataHistory.json();
            setHistory(history);
        };
        fetchtheData();
        ScrollTop();
    }, [backend, guest]);
    const years = FilterHistoryYears(history);
    let created, year;
    return (
        <div className="history">
            <Navigation navParks={navParks} />
            <Header />
            <BreadCrumb label="history" />
            <section className="infos">
                <BreadTagsHistory datas={years} />
                {history.map((el, i) => {
                    created = GetYearMonthDay(el.created);
                    year = GetYear(el.created);
                    return (
                        <div className="bloc-history" id={year} key={i}>
                            {years[i] ? <div className="years">{year}</div> : ''}
                            <div className="gallery-and-text">
                                <BlockGallery id={el.id} datas={LogoImgHistory(created)} />
                                <div className="item-history">
                                    <div className="year">{GetDateShortFR(el.created)}</div>
                                    <div className="title-history">{el.title}</div>
                                    <div className="text-history">{el.description}</div>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </section>
            <BackTop />
            <Footer />
        </div>
    )
}